import React from 'react';
import IndustryDetailsForm from './IndustryDetailsForm';

export default class IndustryDetails extends React.Component {
  static displayName = 'IndustryDetails';

  constructor(props) {
    super(props);
    this.state = {
      isSaving: false,
      errorMsg: undefined,
      successMsg: undefined
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    const industryId = parseInt(this.props.params.industryId, 10);
    this.props.updateCurrentIndustry(industryId);

    this.screenReaderContent.focus();
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  handleSubmit = values => {
    this.setState({ isSaving: true, errorMsg: undefined });
    if (values.id) {
      this.props
        .updateIndustry(values)
        .then(
          response => this.success(response, false),
          error => this.failure(error)
        );
    } else {
      this.props
        .addIndustry(values)
        .then(
          response => this.success(response, true),
          error => this.failure(error)
        );
    }
  };

  success = (response, redirect = false) => {
    this.setState({
      isSaving: false,
      errorMsg: undefined,
      successMsg: 'Success!'
    });
    this.timeoutId = setTimeout(
      () => this.setState({ successMsg: undefined }),
      3000
    );

    if (redirect) {
      const newIndustryId = response.data.id;
      this.props.router.push(`/industries/${newIndustryId}`);
    }
  };

  failure = error => {
    this.setState({
      isSaving: false,
      isArchiving: false,
      errorMsg: error.data.message
    });
  };

  render() {
    const { currentIndustry } = this.props;
    return (
      <div>
        <h3
          className="screen-reader-only"
          tabIndex="-1"
          ref={i => (this.screenReaderContent = i)}
        >
          Showing details for industry {currentIndustry.name}
        </h3>
        <IndustryDetailsForm
          onSubmit={this.handleSubmit}
          initialValues={currentIndustry}
          currentIndustry={currentIndustry}
          enableReinitialize={true}
          isSaving={this.state.isSaving}
          errorMsg={this.state.errorMsg}
          successMsg={this.state.successMsg}
          isNew={this.props.params.industryId === 'new'}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/industries/IndustryDetails.js